<ng-template #colaboradorTemplate>
  <!-- Área do Colaborador -->
  <section>
    <div class="card">
      <div class="card-body">
        <div class="card-header card-form-header">
          <div class="card-content">
            <div class="card-body">
              <div class="col-12">
                <div class="form-group row">
                  <!-- Dados do Beneficiário -->
                  <div class="col-md-12 d-flex justify-content-between align-items-center mb-2">
                    <div class="dados-beneficiario">
                      <label class="preto-geia"><b>Nome</b></label>
                      <span>
                        <b>{{ nome }}</b>
                      </span>
                    </div>
                    <div class="d-flex">
                      <div class="dados-beneficiario mr-3">
                        <label class="preto-geia"><b>Data de Nascimento</b></label>
                        <span class="text-center">
                          <b>{{ aniversario | date: 'dd/MM/yyyy' }}</b>
                        </span>
                      </div>
                      <div class="dados-beneficiario mr-3">
                        <label class="preto-geia"><b>Estado Civil</b></label>
                        <span class="text-center">
                          <b>{{ estadoCivil }}</b>
                        </span>
                      </div>
                      <div class="dados-beneficiario mr-3">
                        <label class="preto-geia"><b>Tipo de Proposta</b></label>
                        <span class="text-center">
                          <b>{{ descricaoTipoProposta }}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Perguntas do Titular -->
                  <!-- <pre>{{ listaDeRespostaDoBeneficiario[0] | json }}</pre> -->
                  <div
                    *ngFor="let item of listaDeRespostaDoBeneficiario; let indexPergunta = index"
                    class="col-md-12 col-sm-12 mt-2">
                    <div class="row">
                      <div class="col-xl-12 col-md-12">
                        <div class="card">
                          <div class="card-header d-flex">
                            <!-- Mostrar Botões -->
                            <div
                              *ngIf="item.codeQuestion !== 27 && item.codeQuestion !== 28"
                              role="group"
                              class="btn-group d-flex justify-content-center align-items-center mr-2"
                              style="width: 120px">
                              <button
                                class="btn btn-round box-shadow-4"
                                style="width: 50px; color: #f8f9fa"
                                [ngClass]="{
                                  'btn-selecionado': botoesSelecionados[indexPergunta] === true
                                }"
                                [ngStyle]="{
                                  'background-color': item.response === true ? '#0f3d32' : '#bdbabb'
                                }"
                                (click)="onMostrarEventoColaborador(indexPergunta, true)">
                                Sim
                              </button>
                              <button
                                class="btn btn-round box-shadow-4"
                                style="width: 50px; color: #f8f9fa"
                                [ngClass]="{
                                  'btn-selecionado': botoesSelecionados[indexPergunta] === false
                                }"
                                [ngStyle]="{
                                  'background-color': item.response === false ? '#420209' : '#bdbabb'
                                }"
                                (click)="onMostrarEventoColaborador(indexPergunta, false)">
                                Não
                              </button>
                            </div>
                            <!-- Mostrar Inputs -->
                            <div
                              *ngIf="item.codeQuestion === 27 || item.codeQuestion === 28"
                              class="d-flex align-items-center mr-2"
                              style="width: 120px"
                              [formGroup]="formPerguntas">
                              <input
                                maxlength="3"
                                *ngIf="item.codeQuestion === 27"
                                class="form-control round box-shadow-4 text-center"
                                style="width: 100%; height: 38px; background-color: #f8f9fa"
                                id="height"
                                formControlName="height"
                                type="text"
                                (change)="calculaImc($event); respostaColaborador(indexPergunta)" />
                              <input
                                maxlength="5"
                                *ngIf="item.codeQuestion === 28"
                                class="form-control round box-shadow-4 text-center"
                                style="width: 100%; height: 38px; background-color: #f8f9fa"
                                id="weight"
                                formControlName="weight"
                                type="text"
                                (change)="onChangeIMC(); respostaColaborador(indexPergunta)" />
                            </div>
                            <h3 style="font-size: 1.2em" class="card-title ml-1 d-flex align-items-center">
                              {{ item.pergunta }}
                            </h3>
                          </div>
                          <!-- Add Eventos -->
                          <div
                            class="col-md-12 col-sm-12 d-flex justify-content-end alinhamento-btn-add-event-mobile"
                            *ngIf="mostrarEventoColaborador[indexPergunta]">
                            <button
                              type="button"
                              style="background-color: #407590 !important"
                              class="btn btn-round bg-side-bar-geia white box-shadow-4"
                              (click)="onAdicionarEventoColaborador(indexPergunta)">
                              <i class="ft-plus white"></i>
                              Adicionar Evento
                            </button>
                          </div>
                          <!-- Eventos -->
                          <div
                            class="card-body"
                            *ngIf="mostrarEventoColaborador[indexPergunta] && formArraysColaborador[indexPergunta]">
                            <div [formGroup]="formArraysColaborador[indexPergunta]">
                              <div formArrayName="events">
                                <div
                                  class="row mb-1"
                                  *ngFor="let evento of getControleDeEventos(indexPergunta); let indexEvento = index"
                                  [formGroupName]="indexEvento">
                                  <!-- Data do Evento -->
                                  <div class="col-md-2 col-sm-12 mb-1 data-evento-tablet">
                                    <label for="eventDate">Data do Evento</label>
                                    <ng-select
                                      id="{{ indexEvento }}"
                                      class="round shadow"
                                      formControlName="eventDate"
                                      [searchable]="false"
                                      [ngClass]="{
                                        'is-invalid':
                                          evento.get('eventDate')?.invalid &&
                                          (evento.get('eventDate')?.touched || isFormSubmited)
                                      }"
                                      (change)="gravarEventosColaborador(indexPergunta)">
                                      <ng-option *ngFor="let item of listaDataEvento" [value]="item.value">
                                        {{ item.description }}
                                      </ng-option>
                                    </ng-select>
                                    <app-validacao-form-input
                                      [nomeFormulario]="evento"
                                      nomeCampo="eventDate"
                                      [maxLength]="250"
                                      [minLength]="10"
                                      [isFormSubmited]="isFormSubmited"
                                      [campoTocado]="true"></app-validacao-form-input>
                                  </div>
                                  <!-- CID -->
                                  <div class="form-group col-sm-12 col-md-3 especificacoes-tablet">
                                    <label for="cid">CID</label>
                                    <ng-select
                                      id="{{ indexEvento }}"
                                      (search)="buscarCids($event, indexEvento)"
                                      (change)="gravarEventosColaborador(indexPergunta)"
                                      class="round shadow ng-select-custom-cid"
                                      formControlName="cid"
                                      bindLabel="description"
                                      bindValue="id"
                                      [ngClass]="{
                                        'is-invalid':
                                          evento.get('cid')?.invalid && (evento.get('cid')?.touched || isFormSubmited)
                                      }">
                                      <ng-option *ngFor="let item of listaCidsPorCampo[indexEvento]" [value]="item.id">
                                        {{ item.cidCode }} -
                                        {{ item.description }}
                                      </ng-option>
                                    </ng-select>
                                    <app-validacao-form-input
                                      [nomeFormulario]="evento"
                                      nomeCampo="cid"
                                      [maxLength]="250"
                                      [minLength]="1"
                                      [isFormSubmited]="isFormSubmited"
                                      [campoTocado]="true"></app-validacao-form-input>
                                  </div>
                                  <!-- Cumprir CPT -->
                                  <div class="form-group col-sm-12 col-md-2 especificacoes-tablet text-center">
                                    <label for="cpt">Cumprir CPT</label>
                                    <div *ngIf="getCumprirCPT(indexPergunta, indexEvento) === null">
                                      <div
                                        role="group"
                                        class="btn-group d-flex justify-content-center align-items-center"
                                        style="margin-bottom: -7px">
                                        <label class="btn btn-round box-shadow-4 bg-success text-white">
                                          <input
                                            type="radio"
                                            formControlName="cpt"
                                            (click)="selecionarBotaoCPT(indexPergunta, indexEvento, 'sim')"
                                            class="d-none"
                                            [ngClass]="{
                                              'is-invalid':
                                                evento.get('cpt')?.invalid &&
                                                (evento.get('cpt')?.touched || isFormSubmited)
                                            }" />
                                          Sim
                                        </label>
                                        <label class="btn btn-round box-shadow-4 bg-danger text-white">
                                          <input
                                            type="radio"
                                            formControlName="cpt"
                                            (click)="selecionarBotaoCPT(indexPergunta, indexEvento, 'nao')"
                                            class="d-none"
                                            [ngClass]="{
                                              'is-invalid':
                                                evento.get('cpt')?.invalid &&
                                                (evento.get('cpt')?.touched || isFormSubmited)
                                            }" />
                                          Não
                                        </label>
                                      </div>
                                      <app-validacao-form-input
                                        [nomeFormulario]="evento"
                                        nomeCampo="cpt"
                                        [maxLength]="250"
                                        [minLength]="10"
                                        [isFormSubmited]="isFormSubmited"
                                        [campoTocado]="true"></app-validacao-form-input>
                                    </div>
                                    <div *ngIf="getCumprirCPT(indexPergunta, indexEvento) === 'sim'">
                                      <label
                                        class="btn btn-round box-shadow-4 bg-success text-white w-100"
                                        (click)="selecionarBotaoCPT(indexPergunta, indexEvento, null)">
                                        Sim
                                      </label>
                                    </div>
                                    <div *ngIf="getCumprirCPT(indexPergunta, indexEvento) === 'nao'">
                                      <label
                                        class="btn btn-round box-shadow-4 bg-danger text-white w-100"
                                        (click)="selecionarBotaoCPT(indexPergunta, indexEvento, null)">
                                        Não
                                      </label>
                                    </div>
                                  </div>
                                  <!-- Motivo -->
                                  <div class="form-group col-sm-12 col-md-3 especificacoes-tablet">
                                    <label for="reason">Motivo</label>
                                    <input
                                      type="text"
                                      class="round form-control"
                                      (change)="gravarEventosColaborador(indexPergunta)"
                                      id="reason"
                                      maxlength="250"
                                      formControlName="reason"
                                      [ngClass]="{
                                        'is-invalid':
                                          evento.get('reason')?.invalid &&
                                          (evento.get('reason')?.touched || isFormSubmited)
                                      }" />
                                    <app-validacao-form-input
                                      [nomeFormulario]="evento"
                                      nomeCampo="reason"
                                      [maxLength]="250"
                                      [minLength]="10"
                                      [isFormSubmited]="isFormSubmited"
                                      [campoTocado]="true"></app-validacao-form-input>
                                  </div>
                                  <!-- Exibir na DS -->
                                  <div class="form-group col-sm-12 col-md-2 especificacoes-tablet text-center">
                                    <label for="displayDs">Exibir na DS</label>

                                    <!-- Quando Exibir DS está como "sim" ou quando está desabilitado -->
                                    <div
                                      *ngIf="
                                        getExibirDS(indexPergunta, indexEvento) === 'sim' ||
                                        isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)
                                      ">
                                      <label
                                        [class.disabled]="isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)"
                                        [class.bg-success]="!isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)"
                                        [class.bg-secondary]="isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)"
                                        [class.cursor-not-allowed]="
                                          isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)
                                        "
                                        class="btn btn-round box-shadow-4 text-white w-100"
                                        (click)="
                                          !isBtnDisplayDSDesabilitado(indexPergunta, indexEvento) &&
                                            selecionarBotaoExibirDS(indexPergunta, indexEvento, null)
                                        ">
                                        Sim
                                      </label>
                                    </div>

                                    <!-- Quando Exibir DS está como "não" -->
                                    <div *ngIf="getExibirDS(indexPergunta, indexEvento) === 'nao'">
                                      <label
                                        [class.disabled]="isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)"
                                        [class.bg-danger]="!isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)"
                                        [class.bg-secondary]="isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)"
                                        [class.cursor-not-allowed]="
                                          isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)
                                        "
                                        class="btn btn-round box-shadow-4 text-white w-100"
                                        (click)="
                                          !isBtnDisplayDSDesabilitado(indexPergunta, indexEvento) &&
                                            selecionarBotaoExibirDS(indexPergunta, indexEvento, null)
                                        ">
                                        Não
                                      </label>
                                    </div>

                                    <!-- Quando Exibir DS está null e não está desabilitado -->
                                    <div
                                      *ngIf="
                                        getExibirDS(indexPergunta, indexEvento) === null &&
                                        !isBtnDisplayDSDesabilitado(indexPergunta, indexEvento)
                                      ">
                                      <div
                                        role="group"
                                        class="btn-group d-flex justify-content-center align-items-center"
                                        style="margin-bottom: -7px">
                                        <!-- Botão Sim -->
                                        <label class="btn btn-round box-shadow-4 bg-success text-white">
                                          <input
                                            type="radio"
                                            formControlName="displayDs"
                                            (click)="selecionarBotaoExibirDS(indexPergunta, indexEvento, 'sim')"
                                            class="d-none"
                                            [ngClass]="{
                                              'is-invalid':
                                                evento.get('displayDs')?.invalid &&
                                                (evento.get('displayDs')?.touched || isFormSubmited)
                                            }" />
                                          Sim
                                        </label>

                                        <!-- Botão Não -->
                                        <label class="btn btn-round box-shadow-4 bg-danger text-white">
                                          <input
                                            type="radio"
                                            formControlName="displayDs"
                                            (click)="selecionarBotaoExibirDS(indexPergunta, indexEvento, 'nao')"
                                            class="d-none"
                                            (change)="gravarEventosColaborador(indexPergunta)"
                                            [ngClass]="{
                                              'is-invalid':
                                                evento.get('displayDs')?.invalid &&
                                                (evento.get('displayDs')?.touched || isFormSubmited)
                                            }" />
                                          Não
                                        </label>
                                      </div>
                                      <app-validacao-form-input
                                        [nomeFormulario]="evento"
                                        nomeCampo="displayDs"
                                        [maxLength]="250"
                                        [minLength]="10"
                                        [isFormSubmited]="isFormSubmited"
                                        [campoTocado]="true"></app-validacao-form-input>
                                    </div>
                                  </div>
                                  <!-- Especificações -->
                                  <div class="form-group col-sm-12 col-md-11 especificacoes-tablet mb-5">
                                    <label for="descriptionEvent">Especificações</label>
                                    <textarea
                                      type="text"
                                      class="round form-control"
                                      (change)="
                                        onDescriptionChange(indexPergunta, indexEvento);
                                        gravarEventosColaborador(indexPergunta)
                                      "
                                      id="descriptionEvent"
                                      maxlength="1000"
                                      formControlName="descriptionEvent"
                                      [ngClass]="{
                                        'is-invalid':
                                          evento.get('descriptionEvent')?.invalid &&
                                          (evento.get('descriptionEvent')?.touched || isFormSubmited)
                                      }"></textarea>
                                    <app-validacao-form-input
                                      [nomeFormulario]="evento"
                                      nomeCampo="descriptionEvent"
                                      [maxLength]="250"
                                      [minLength]="10"
                                      [isFormSubmited]="isFormSubmited"
                                      [campoTocado]="true"></app-validacao-form-input>
                                  </div>
                                  <!-- Botão Excluir -->
                                  <div
                                    class="col-md-1 col-sm-12 mb-1 btn-excluir-evento-tablet d-flex justify-content-center align-items-center">
                                    <button
                                      type="button"
                                      (click)="removerEventoColaborador(indexPergunta, indexEvento)"
                                      class="btn btn-danger round">
                                      <i class="fa fa-trash white"></i>
                                    </button>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12 mt-2" *ngIf="mostrarIMC">
                    <div class="row">
                      <div class="col-xl-12 col-md-12">
                        <div class="card">
                          <div class="card-header d-flex">
                            <h3 style="font-size: 1.2em" class="card-title ml-1 d-flex align-items-center">
                              <b>IMC: {{ this.imc }} - {{ nome }} está {{ this.imcClassificacao }}</b>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Termo -->
                  <div class="card-header card-form-header mt-1">
                    <div class="card" style="margin-bottom: 1rem">
                      <h3 class="text-center form-section">
                        <b>OPÇÃO PARA DOENÇAS E/OU LESÕES PRÉ-EXISTENTES</b>
                      </h3>
                      <div class="col-md-12 col-sm-12 mt-1">
                        <p class="preto-geia">
                          Havendo declaração de doenças ou lesões preexistentes e tendo sido orientado, estou ciente da
                          Cobertura Parcial Temporária (CPT) – período ininterrupto de 24 meses em que estará suspensa a
                          cobertura de Procedimentos de Alta Complexidade (PAC), leitos de alta tecnologia e
                          procedimentos cirúrgicos relacionados às doenças e lesões pré-existentes.
                        </p>
                      </div>
                      <div class="col-md-12 col-sm-12 mt-1">
                        <p class="preto-geia">
                          Eu,
                          <b>{{ nome }}</b>
                          , declaro ainda que:
                        </p>
                      </div>
                      <div class="card-content col-md-12 col-sm-12 mt-1">
                        <form [formGroup]="formPerguntas">
                          <div class="form-group mb-1 col-sm-12 col-md-12">
                            <div class="row">
                              <label style="cursor: pointer">
                                <input
                                  formControlName="optionForPreExistingIllnesses"
                                  [value]="1"
                                  id="active"
                                  type="radio"
                                  class="input-radio off"
                                  name="optionForPreExistingIllnesses"
                                  (change)="respostaColaboradorTermo()"
                                  checked />
                                &nbsp;&nbsp; Fui orientado por médico cooperado à UNIMED FESP no preenchimento da
                                declaração de saúde;
                              </label>
                            </div>
                            <div class="row">
                              <label style="cursor: pointer">
                                <input
                                  formControlName="optionForPreExistingIllnesses"
                                  [value]="2"
                                  id="Inactive"
                                  type="radio"
                                  class="input-radio on"
                                  name="optionForPreExistingIllnesses"
                                  (change)="respostaColaboradorTermo()" />
                                &nbsp;&nbsp; Fui orientado por um médico particular, no preenchimento da declaração de
                                saúde, arcando com o ônus da consulta;
                              </label>
                            </div>
                            <div class="row">
                              <label style="cursor: pointer">
                                <input
                                  formControlName="optionForPreExistingIllnesses"
                                  [value]="3"
                                  id="Inactive"
                                  type="radio"
                                  class="input-radio on"
                                  name="optionForPreExistingIllnesses"
                                  (change)="respostaColaboradorTermo()" />
                                &nbsp;&nbsp; Entendi o conteúdo de todas as perguntas da declaração de saúde e dispensei
                                a orientação médica para respondê-las, assumindo total responsabilidade pelas
                                informações por mim prestadas.
                              </label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <!-- Observação -->
                  <div class="col-12">
                    <div class="form-group row">
                      <h3 class="form-section">
                        <b>Observação Gestão Saude</b>
                      </h3>
                      <div class="col-md-12 col-sm-12 mt-1">
                        <div class="row" [formGroup]="formPerguntas">
                          <textarea
                            formControlName="obsGs"
                            (input)="contarCaracteres($event)"
                            maxlength="3000"
                            rows="10"
                            class="form-control round box-shadow-4"
                            (change)="campoObservacao()"></textarea>
                          <span class="contador-caracteres">{{ caracteresDigitados }}/3000</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>
<!-- Área do Beneficiário -->
<section class="row" id="top-form" *ngIf="!ehColaborador; else colaboradorTemplate">
  <div class="col-12 espacamento-mobile" *ngIf="textoDaPergunta; else naoTemPerguntas">
    <div class="card card-form">
      <div class="card-header card-form-header mt-1">
        <h3 class="text-center form-section" *ngIf="retornoDS">
          Pergunta {{ indexDaListaDePerguntas }}
          de
          {{ qtdPerguntasFormAtual }}
        </h3>
        <h4 class="text-center mt-2 mb-3" style="color: var(--color-secondary)">
          <ng-container *ngIf="!retornoDS; else nomeNormal">
            <span class="mb-1">
              <b>{{ nome }}</b>
            </span>
            <br />
          </ng-container>
          <ng-template #nomeNormal>
            <span class="mb-1">{{ nome }}</span>
          </ng-template>
          <br />
          {{ textoDaPergunta }}
        </h4>
        <div class="d-flex iconic-box-ds fadeInUp col-md-12 estrutura-mobile">
          <div class="col-md-2 col-sm-12 alinhamento-img-mobile">
            <div class="icon-ds">
              <img [src]="imgDaPergunta" alt="Icon" width="80px" />
            </div>
          </div>
          <!-- Descrição -->
          <div class="d-flex justify-content-center col-md-10" *ngIf="!PesoEAltura">
            <div class="col-md-10 col-sm-12">
              <p class="preto-geia">
                {{ descricaoDaPergunta }}
              </p>
            </div>
          </div>

          <form [formGroup]="formPerguntas" *ngIf="PesoEAltura" style="width: 100%">
            <!-- Input text para a pergunta de altura -->
            <div class="form-group mb-1 col-sm-12 col-md-10 text-center d-flex justify-content-center" *ngIf="ehAltura">
              <div
                class="form-group mb-1 col-sm-12 col-md-4 input-with-suffix altura tamanho-campo-medio-formulario-tablet">
                <input
                  maxlength="3"
                  class="form-control round"
                  id="height"
                  formControlName="height"
                  type="text"
                  oninput="
                    this.value = Math.min(parseInt(this.value))
                      .toString()
                      .replace(/[^0-9]/g, '')
                  "
                  [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'" />
              </div>
            </div>
            <!-- Input text para a pergunta de peso -->
            <div class="form-group mb-1 col-sm-12 col-md-10 text-center d-flex justify-content-center" *ngIf="ehPeso">
              <div
                class="form-group mb-1 col-sm-12 col-md-4 input-with-suffix peso tamanho-campo-medio-formulario-tablet">
                <input
                  maxlength="5"
                  (input)="permitirNumeroVirgulaPonto($event)"
                  (change)="onChangeIMC(idBeneficiario)"
                  class="form-control round"
                  id="weight"
                  formControlName="weight"
                  type="text"
                  [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'" />
              </div>
            </div>
          </form>
        </div>
        <div class="card-content">
          <form [formGroup]="formPerguntas">
            <div class="col-12">
              <div class="form-group row">
                <div class="col-12 d-flex justify-content-around" *ngIf="ehIMC">
                  <div class="d-flex justify-content-end align-items-sm-center">
                    <h3>
                      Seu IMC é:
                      <span class="preto-geia bold-preto-600">{{ imc }}</span>
                      <br />
                      Você está {{ imcClassificacao }}
                    </h3>
                    <img
                      src="../../../../../../assets/app-assets/images/icones-geia/declaracao-saude/corpo.png"
                      alt="Icon"
                      width="80px"
                      class="ml-1" />
                  </div>
                </div>
                <div class="form-group mb-1 col-sm-12 col-md-12 text-center" *ngIf="!PesoEAltura">
                  <label
                    style="margin-right: 50px"
                    [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'">
                    <input
                      (change)="onMostrarEvento()"
                      formControlName="response"
                      [value]="true"
                      [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'"
                      type="radio"
                      class="input-radio off"
                      name="response" />
                    SIM
                  </label>
                  <label [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'">
                    <input
                      (change)="onMostrarEvento()"
                      formControlName="response"
                      [value]="false"
                      [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'"
                      type="radio"
                      class="input-radio on"
                      name="response" />
                    NÃO
                  </label>
                </div>
                <!-- Eventos Retorno DS -->
                <div class="col-md-12">
                  <div class="row mb-1" *ngFor="let evento of getEventosRetornoDS(); let i = index">
                    <!-- Data do Evento -->
                    <div class="form-group col-sm-12 col-md-3 especificacoes-tablet">
                      <label for="eventDate">Data do Evento</label>
                      <input
                        type="text"
                        class="round form-control"
                        id="eventDate"
                        maxlength="65"
                        readonly
                        [value]="evento.eventDate" />
                    </div>
                    <!-- Cid -->
                    <div class="form-group col-sm-12 col-md-4 especificacoes-tablet">
                      <label for="cid">Cid</label>
                      <input type="text" class="round form-control" id="cid" readonly [value]="evento.cid" />
                    </div>
                    <!-- Cumprir CPT -->
                    <div class="form-group col-sm-12 col-md-2 especificacoes-tablet text-center">
                      <label for="cpt">Cumprir CPT</label>
                      <div *ngIf="evento.cpt === true">
                        <label class="btn btn-round box-shadow-4 bg-success text-white w-100">Sim</label>
                      </div>
                      <div *ngIf="evento.cpt === false">
                        <label class="btn btn-round box-shadow-4 bg-danger text-white w-100">Não</label>
                      </div>
                    </div>
                    <!-- Motivo -->
                    <div class="form-group col-sm-12 col-md-3 especificacoes-tablet">
                      <label for="reason">Motivo</label>
                      <input
                        type="text"
                        class="round form-control"
                        id="reason"
                        maxlength="65"
                        readonly
                        [value]="evento.reason" />
                    </div>
                    <!-- Especificações -->
                    <div class="form-group col-sm-12 col-md-12 especificacoes-tablet mb-5">
                      <label for="descriptionEvent">Especificações</label>
                      <textarea
                        type="text"
                        class="round form-control"
                        id="descriptionEvent"
                        maxlength="1000"
                        readonly
                        >{{ evento.descriptionEvent }}</textarea
                      >
                    </div>
                  </div>
                </div>
                <!-- Eventos -->
                <ng-container *ngIf="!somenteLeituraStep">
                  <div
                    class="col-md-12 col-sm-12 d-flex justify-content-end alinhamento-btn-add-event-mobile"
                    *ngIf="mostrarEvento && !ehAltura && !ehPeso">
                    <button
                      type="button"
                      style="background-color: #407590 !important"
                      class="btn btn-round bg-side-bar-geia white box-shadow-4"
                      (click)="onAdicionarEvento()"
                      [ngStyle]="{
                        cursor: listaEventos.length >= 4 ? 'not-allowed' : 'pointer'
                      }">
                      <i class="ft-plus white"></i>
                      Adicionar Evento
                    </button>
                  </div>
                </ng-container>
                <div formArrayName="listaEventos" class="col-md-12" *ngIf="mostrarEvento">
                  <div class="row mb-1">
                    <ng-container *ngFor="let evento of listaEventos.controls; let i = index" [formGroupName]="i">
                      <div class="col-md-3 col-sm-12 mb-1 data-evento-tablet">
                        <label for="eventDate">Data do Evento</label>
                        <ng-select
                          id="{{ i }}"
                          class="round shadow"
                          (change)="verificarDuplicidade($event, i)"
                          formControlName="eventDate"
                          [readonly]="somenteLeituraStep"
                          [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'"
                          [ngClass]="{
                            'is-invalid': evento.get('eventDate')?.invalid && isFormSubmited,
                            'bg-ligth': somenteLeituraStep,
                            'no-drop !important': somenteLeituraStep
                          }">
                          <ng-option *ngFor="let item of listaDataEvento" [value]="item.value">
                            {{ item.description }}
                          </ng-option>
                        </ng-select>
                        <app-validacao-form-input
                          [nomeFormulario]="evento"
                          nomeCampo="eventDate"
                          [maxLength]="250"
                          [minLength]="10"
                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                      </div>
                      <div class="form-group col-sm-12 col-md-8 especificacoes-tablet">
                        <label for="descriptionEvent">Especificações</label>
                        <input
                          type="text"
                          class="round form-control"
                          id="descriptionEvent"
                          [readonly]="somenteLeituraStep"
                          maxlength="65"
                          formControlName="descriptionEvent"
                          [style.cursor]="somenteLeituraStep ? 'no-drop !important' : 'pointer !important'"
                          [ngClass]="{
                            'is-invalid': evento.get('descriptionEvent')?.invalid && isFormSubmited,
                            'bg-ligth': somenteLeituraStep,
                            'no-drop !important': somenteLeituraStep
                          }" />
                        <app-validacao-form-input
                          [nomeFormulario]="evento"
                          nomeCampo="descriptionEvent"
                          [maxLength]="250"
                          [minLength]="10"
                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                      </div>
                      <div
                        *ngIf="!somenteLeituraStep"
                        class="col-md-1 col-sm-12 mb-1 btn-excluir-evento-tablet"
                        style="margin-bottom: 1.5rem !important">
                        <button type="button" (click)="removerEvento(i)" class="btn btn-danger round">
                          <i class="fa fa-trash white"></i>
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <ng-template #naoTemPerguntas>
    <ng-container>
      <div
        class="mt-5 alert row justify-content-center align-items-center col-md-12 round alert-icon-left alert-arrow-left alert-danger alert-dismissible mb-2"
        role="alert">
        <span class="alert-icon"><i class="fa fa-1x fa-exclamation"></i></span>
        <ng-container>
          <h4 class="text-bold-500">
            <h1>Não foi localizado nenhuma pergunta.</h1>
          </h4>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>
</section>
<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  <p style="color: white">Carregando....</p>
</ngx-spinner>
